"use client"

import * as React from "react"

import { cn } from "@/lib/utils"
import { useThemeConfig } from "@/hooks/use-theme-config"

// Terminal mode styles for Bloomberg terminal look
const terminalCardStyles = "!bg-black !border-emerald-500 !shadow-[0_0_10px_rgba(16,185,129,0.2)]"
const terminalTextStyles = "!text-emerald-400"
const terminalMutedTextStyles = "!text-emerald-500/70"

function Card({ className, ...props }: React.ComponentProps<"div">) {
  const { isTerminal, mounted } = useThemeConfig()
  const showTerminalStyles = mounted && isTerminal

  return (
    <div
      data-slot="card"
      className={cn(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border shadow-sm",
        showTerminalStyles && terminalCardStyles,
        className
      )}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn("flex flex-col gap-1.5 px-6", className)}
      {...props}
    />
  )
}

function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  const { isTerminal, mounted } = useThemeConfig()
  const showTerminalStyles = mounted && isTerminal

  return (
    <div
      data-slot="card-title"
      className={cn(
        "leading-none font-semibold",
        showTerminalStyles && terminalTextStyles,
        className
      )}
      {...props}
    />
  )
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  const { isTerminal, mounted } = useThemeConfig()
  const showTerminalStyles = mounted && isTerminal

  return (
    <div
      data-slot="card-description"
      className={cn(
        "text-muted-foreground text-sm",
        showTerminalStyles && terminalMutedTextStyles,
        className
      )}
      {...props}
    />
  )
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn("px-6", className)}
      {...props}
    />
  )
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn("flex items-center px-6", className)}
      {...props}
    />
  )
}

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
